<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الاسم:</label>
          <div>{{ dataRow.User.name }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">رقم الجوال:</label>
          <div>{{ dataRow.User.mobile }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">المنطقة:</label>
          <div>{{ dataRow.Region.name }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">المدينة:</label>
          <div>{{ dataRow.City.name }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الحي:</label>
          <div>{{ dataRow.Neighborhood.name }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">نوع العقار:</label>
          <div>{{ dataRow.PropertyType.name }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">حالة العقار:</label>
          <div>{{ (dataRow.purpose == 'for_sale')? 'للبيع' : 'للإيجار' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">نوع الساكن:</label>
          <div>{{ (dataRow.propertyType == 'singles')? 'عزاب' : 'عوائل' }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">السعر من:</label>
          <div>{{ dataRow.priceFrom }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">السعر إلى:</label>
          <div>{{ dataRow.priceTo }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">عدد الغرف:</label>
          <div>{{ dataRow.roomsCount }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">عمر العقار:</label>
          <div>{{ dataRow.age }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">المساحة من (م²):</label>
          <div>{{ dataRow.area }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">المساحة الى (م²):</label>
          <div>{{ dataRow.areaTo }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">تاريخ الطلب:</label>
          <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">حالة الطلب:</label>
          <div>{{ statusChoices[status] }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">مصدر الطلب:</label>
          <div>
            <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
            <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
            <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
            <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
            <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
            <span v-else class="text-muted">غير محدد</span>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';

export default {
  name: 'ProRequestView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'new',
    }
  },
  methods: {
    formatDate,
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
    }
    this.statusChoices = this.statusObject;
  }
}
</script>
